export default "__VITE_ASSET__SW8Oeel9__"